const CONNECT = "CONNECT";


export function useConnectLogin() {
    const cookieName = "approval_connect_login";
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());

    //in prod we always use ODP  login
    if (window.ENVIRONMENT?.NAME === "prod")
        return false;


    const connectLoginMethod = window.ENVIRONMENT?.LOGIN_METHOD === CONNECT;
    const connectCookieExists = cookies.some(cookie => cookie.startsWith(`${cookieName}=`));

    return connectCookieExists || connectLoginMethod;
}